import { MobilfunkEntry } from '../model/mobilfunk';
import { DataFetcher } from './fetcher/DataFetcher';
import { RepositoryNocoDbBase } from './repositoryNocoDbBase.ts';

export interface MobilfunkSearchParams {
	//TODO
	_term?: string;
	countries?: string;
	duration?: string;
	radiation_source?: string;
	radiation_sleep?: string;
	symptom_disease?: string;
	distance_mast?: string;
	title?: string;
	tags?: string;
	report_from?: string;
	date?: string;
	license?: string;
	country?: string;
	page?: number;
}

export class MobilfunkRepository extends RepositoryNocoDbBase<
	MobilfunkEntry,
	MobilfunkSearchParams
> {
	// protected readonly API_ROUTE = `${process.env.NOCO_DB_API_URL}/tables/${process.env.NOCO_DB_MOBILFUNK_TABLE_ID}/records`;
	protected readonly API_ROUTE = `${process.env.API_URL}v2/noco/tables/${process.env.NOCO_DB_MOBILFUNK_TABLE_ID}/records`;

	protected readonly META_ROUTE = `${process.env.API_URL}v2/meta/tables/${process.env.NOCO_DB_MOBILFUNK_TABLE_ID}`;

	public constructor(_fetcher: DataFetcher) {
		super(_fetcher);
	}

	async getPageInfo() {
		return (await this.search({ search: { page: 1 } }))?.pageInfo;
	}

	protected composeSearchRoute(search?: MobilfunkSearchParams) {
		const staticCase = '(is_verified,eq,Yes)';
		const where: string[] = [staticCase];

		// Command creators
		// TODO: find better location to provide this functions
		const createLikeCommand = (
			fieldName: keyof MobilfunkEntry,
			value: string
		) => `(${fieldName},like,${value})`;

		const createEqualCommand = (
			fieldName: keyof MobilfunkEntry,
			value: string
		) => `(${fieldName},eq,${value})`;

		const createExtactDateCommand = (fieldName: string, value: string) =>
			`(${fieldName},eq,exactDate,${value})`;

		// TODO: Statisch für demo-zwecke: jeder Filter (z.B. 'country') muss in einen loop
		const selectFilters = [
			'country',
			'duration',
			'distance_mast',
			'symptom_disease',
			'radiation_sleep',
			'radiation_source',
		];
		selectFilters.forEach((name) => {
			if (!search) {
				return;
			}

			if (search[name]) {
				const subWhere: string[] = [];
				const values = search[name].split(',');
				values.forEach((value: string) => {
					subWhere.push(createLikeCommand(name as keyof MobilfunkEntry, value));
				});
				if (subWhere.length > 1) {
					where.push('(' + subWhere.join('~or') + ')');
				} else {
					where.push(subWhere[0]);
				}
			}
		});

		for (const [key, value] of Object.entries(search ?? {})) {
			if (!value) continue; // Skip for empty values

			const searchFields: (keyof MobilfunkEntry)[] = ['remark'];

			switch (key) {
				case '_term':
					// search with `_term` in multiple fields
					searchFields.map((field) =>
						where.push(createLikeCommand(field, value))
					);
					break;
				// case "date":
				//     where.push(createExtactDateCommand(key, value));
				//     break;
				default:
					// For other fields, search in the exact same field name
					// where.push(createLikeCommand(key, value));
					break;
			}
		}

		// TODO: Implemente better (like `where`  condition) by appling sort dropdown
		const sortCommand = 'sort=-CreatedAt';

		// Combine route with search params
		// Example: https://noco.elaion.ch/api/v2/tables/mtvs0nudqrspnlj/records?where=%28title%2Clike%2Cserbien%29%7Eor%28tags%2Clike%2Cserbien%29%7Eor%28report_from%2Clike%2Cserbien%29
		// API Documentation:
		// - https://noco.elaion.ch/api/v2/meta/bases/ppliqomdhpa476f/swagger
		// - https://data-apis-v2.nocodb.com/#tag/Table-Records/operation/db-data-table-row-list
		// - https://docs.nocodb.com/0.109.7/developer-resources/rest-apis/#query-params

		const whereQuery = '&where=@' + where.join('~and');

		// const searchParam = new URLSearchParams({ where: where.join('~or') });
		// return `${this.API_ROUTE}?${searchParam}&${sortCommand}`;
		// console.log(`${this.API_ROUTE}?page=${search?.page}`)

		return `${this.API_ROUTE}?page=${search?.page}${whereQuery}&sort=-originally_published_at,-CreatedAt`;

		// As default return route without `where` param
		return `${this.API_ROUTE}?${sortCommand}`;
	}
}
